import { Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function StickyFooterCard() {
	const [isMinimized, setIsMinimized] = useState(false);
	const [scrollY, setScrollY] = useState<number>(0);
	const show = scrollY > 200;

	const handleScroll = () => {
		setScrollY(window.scrollY);
	};

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<Transition
			show={show}
			enter="transition-opacity duration-150"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="transition-opacity duration-150"
			leaveFrom="opacity-100"
			leaveTo="scale-0 opacity-0"
		>
			{isMinimized ? (
				<div className="fixed bottom-0 left-0 z-20 flex w-full flex-row flex-wrap items-center justify-between bg-[url('/images/listing-page/sticky-footer-bg.svg')] bg-cover bg-no-repeat md:flex-nowrap">
					<div className="mx-auto flex w-full max-w-6xl items-center justify-between py-4">
						<div className="flex w-full items-center gap-4">
							<div className="h-12 w-12">
								<Image
									src="/images/listing-page/fortress-icon.svg"
									alt="Image"
									className="h-full w-full rounded object-contain"
									width={80}
									height={80}
								/>
							</div>

							<h1 className="font-bold text-white">FORTRESS</h1>

							<span className="text-sm text-white">Get Fortress Proptech Monday Deal!</span>
						</div>

						<div className="flex items-center gap-4">
							<button className="flex w-max items-center justify-center gap-3 rounded-lg bg-gradient-to-r from-[#005EFF] via-[#642CFD] to-[#9613FC] px-8 py-2 text-sm font-medium uppercase text-white shadow">
								Get Free Demo
							</button>

							<button onClick={() => setIsMinimized(false)}>
								<ChevronUpIcon className=" stroke-white" />
							</button>
						</div>
					</div>
				</div>
			) : (
				<div className="fixed bottom-0 left-0 z-20 w-full bg-[url('/images/listing-page/sticky-footer-bg.svg')] bg-cover bg-no-repeat">
					<div className="flex w-full flex-row flex-wrap items-center justify-between md:flex-nowrap">
						<div className="mx-auto flex w-full max-w-5xl items-start justify-between py-6">
							<div className="flex w-full flex-col items-start justify-between gap-4 md:flex-nowrap">
								<div className="flex w-full flex-col items-start justify-between gap-4 md:flex-nowrap">
									<div className="flex w-max items-start justify-between gap-4 md:flex-nowrap">
										<div className="justify-startgap-2 -mt-10 flex h-24 w-24 items-center font-bold text-white md:w-fit">
											<Image
												src="/images/listing-page/fortress-icon.svg"
												alt="Image"
												className="h-full w-full rounded object-contain"
												width={80}
												height={80}
											/>
										</div>

										<div className="flex flex-col gap-2">
											<h2 className="text-base font-semibold text-white">FORTRESS</h2>
											<h3 className="text-sm text-white">Get Fortress Proptech Monday Deal!</h3>
										</div>
									</div>

									<div className="mt-1 w-96 rounded border border-gray-50/25"></div>
								</div>

								<h4 className="flex gap-1 text-lg font-bold text-white">
									<span>The 2-year plan adds </span>
									<span>
										<span>3 Months Extra</span>
										<div className="-mt-[10px] w-full bg-gradient-to-r from-[#005EFF] via-[#642CFD] to-[#9613FC] p-1"></div>
									</span>
								</h4>
							</div>

							<div className="flex w-full flex-col items-end justify-start">
								<div className="flex w-max items-center justify-end gap-6 pb-8 pt-2">
									<button className="flex w-max items-center justify-center gap-3 rounded-lg bg-gradient-to-r from-[#005EFF] via-[#642CFD] to-[#9613FC] px-8 py-2 text-sm font-medium uppercase text-white shadow">
										Get Free Demo
									</button>

									<button onClick={() => setIsMinimized(true)} className="-mr-12">
										<ChevronDownIcon className=" stroke-white" />
									</button>
								</div>

								<div className="w-64 rounded border border-gray-50/25"></div>
							</div>
						</div>

						<div className="absolute -z-10 flex w-full items-center">
							<div className="mx-auto -mt-12 h-[512px] w-[512px]">
								<Image
									src="/images/listing-page/sticky-footer-occupancy-card.svg"
									alt="Image"
									className="h-full w-full rounded object-contain"
									width={80}
									height={80}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</Transition>
	);
}
